export enum TipoBuscaUnidadeCliente {
  TODOS = "TODOS",
  SOMENTE_UNIDADES = "SOMENTE_UNIDADES",
  SOMENTE_CLIENTES = "SOMENTE_CLIENTES",
  SOMENTE_FORNECEDORES = "SOMENTE_FORNECEDORES",
  UMA_UNIDADE = "UMA_UNIDADE",
  UM_CLIENTE = "UM_CLIENTE",
  UM_FORNECEDOR = "UM_FORNECEDOR",
  GRUPO_UNIDADES = "GRUPO_UNIDADES",
}
